module.exports = __webpack_public_path__ + "img/principalBuilding.aaf9f284.svg";